import { FormObjType } from "DataTypes/Form";

export const ResultForm: FormObjType[] = [
  {
    id: "input-result-name",
    label: "Result Name",
    placeholder: "Enter Result Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-observation-name",
    label: "Observation Name",
    placeholder: "Enter Observation Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "date-orservation-date",
    label: "Observation Date",
    placeholder: "Select Observation Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-observation-value",
    label: "Observation Value",
    placeholder: "Enter Observation Value",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-observation-unit",
    label: "Observation Unit",
    placeholder: "Enter Observation Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
]